import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';

const GoogleLoginButton = ({ text, handler }) => {
  return <SubmitButton text={text} handler={handler} variant="googleLogin" />;
};

GoogleLoginButton.defaultProps = {
  text: 'Continue with Apple',
  handler: () => {}
};

GoogleLoginButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default GoogleLoginButton;
